import { BaseMarkerController } from '../base/baseMarkerController'
import { RectangleMarker } from './rectangleMarker'
import { MarkerModes } from '../../types'

class RectangleMarkerController extends BaseMarkerController<RectangleMarker> {
  declare marker: RectangleMarker

  constructor(marker: RectangleMarker) {
    super()
    this.marker = marker
  }

  mousePressedEvent(): void {
    super.mousePressedEvent()
    const position = this.marker.state.position
    const dimensions = this.marker.state.dimensions
    if (this.marker.isRectDefined()) return

    const isCreating = this.marker.state.mode === MarkerModes.Create

    //Instantiate dimensions and position
    if (isCreating) {
      position.x = this.mouseCoordinateX
      position.y = this.mouseCoordinateY
      dimensions.height = 0
      dimensions.width = 0
    }
  }

  mouseDraggedEvent(): void {
    super.mouseDraggedEvent()
    const state = this.marker.state
    if (state.mode === MarkerModes.Create) {
      const markerPositionDefined = state.position?.x && state.position?.y
      if (markerPositionDefined) {
        if (!this.marker.state.pressedHandle) this.marker.state.pressedHandle = this.marker.state.handles[0]
        state.resizeMarker(this.marker.handles.getPressedHandleIndex(), this.mouseDelta.x, this.mouseDelta.y)
      }
      return
    }

    if (state.isPressed) {
      if (state.pressedHandle) {
        state.resizeMarker(this.marker.handles.getPressedHandleIndex(), this.mouseDelta.x, this.mouseDelta.y)
      } else {
        state.moveMarker(this.mouseDelta.x, this.mouseDelta.y)
      }
    }
  }

  mouseReleasedEvent(): void {
    super.mouseReleasedEvent()
    const marker = this.marker
    const state = this.marker.state
    if (state.mode === MarkerModes.Create && marker.isRectDefined()) {
      if (state.dimensions.height === 0 && state.dimensions.width === 0) {
        //Set to default height and width
        //For intances where user does not drag after pressing
        state.dimensions.height = Math.max(Math.round(50 * this.marker.state.scalingRatio), 1)
        state.dimensions.width = Math.max(Math.round(50 * this.marker.state.scalingRatio), 1)
      }
      marker.handles.populateHandlePositions()
      state.mode = MarkerModes.Edit
      if (typeof marker.markerCreatedCallback === 'function') marker.markerCreatedCallback(this.marker)
    }
  }
}

export { RectangleMarkerController }
